import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';
import { Trans } from 'react-i18next';

import { ASSETS_BASE_URL } from 'src/api/concierge';

export const MoveInCardImage: FC<{ bookingYear: string; isComplete: boolean }> = ({
    bookingYear,
    isComplete,
}) => {
    const { palette } = useTheme();

    return (
        <Stack
            padding="20px"
            width="100%"
            css={{
                borderBottom: `1px solid ${palette.divider}`,
                color: palette.common.white,
                position: 'relative',
            }}
        >
            <Typography
                variant="h1"
                fontSize={{ xs: '46px', md: '52px' }}
                css={{
                    lineHeight: '85%',
                    letterSpacing: '0.02rem',
                    zIndex: 1,
                }}
            >
                <Trans i18nKey="check_in_online_title" values={{ year: bookingYear }} />
            </Typography>

            <img
                css={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    filter: isComplete ? 'grayscale(100)' : undefined,
                }}
                alt="move in background"
                src={`${ASSETS_BASE_URL}/images/move-in-card.jpg`}
            />
        </Stack>
    );
};
